import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TokenService } from 'src/app/services/token.service';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [TranslateModule, CommonModule, MatButton, MatExpansionModule, TablerIconsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormComponent {
  @ViewChild('fr') private formRenderer: ElementRef | undefined;
  @Output() saveEvent = new EventEmitter<any>();
  @Output() formChangedEvent = new EventEmitter<boolean>();
  @Input('formMetaData') formMetaData: any;
  @Input('context') context: any;
  @Input('formEnvironment') formEnvironment: any;
  @Input('compositionId') compositionId?: string;
  @Input() elementsToHide: string[] = [];

  showFormRenderer: boolean = true;

  currentLanguage: string;
  betterResourceUrl: string;
  credentials = {
    authType: 'oauth2',
    token: '',
  };

  formIsValid: boolean = false;
  formIsRendered: boolean;
  debugMode: boolean;
  formChanged: boolean = false;
  ruoli:string[]=[];

  constructor(
    private readonly tokenService: TokenService,
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private readonly keycloakService: KeycloakService,
    public authService: AuthService,
  ) {
    this.betterResourceUrl = environment.betterResourceUrl;
    this.debugMode = !environment.production;
    const token = (this.tokenService.getToken() as string) ?? '';
    this.credentials.token = token;
    this.ruoli=this.keycloakService.getUserRoles();
  }

  ngOnInit() {
    this.context.language = this.translate.currentLang;
    // this.spinnerService.show();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeLanguage(event.lang);
    });
  }

  async formRendered($event: any) {
    console.log($event);

    this.formIsRendered = true;
    this.formChanged = false;
    this.formChangedEvent.emit(this.formChanged);

    if (this.elementsToHide.length > 0) {
      this.hideElements();
    }

    // this.spinnerService.hide();
    // const scriptApi = this.formRenderer!.nativeElement.getScriptApi();
    // scriptApi.setFieldValue('report/context/report_id', this.ehrId);
  }

  valueChange($event: any): void {
    this.formIsValid = this.formRenderer?.nativeElement
      .getScriptApi()
      .validateForm().valid;

    this.formChanged = true;
    this.formChangedEvent.emit(this.formChanged);

    console.log(this.formIsValid);
    console.log(this.formChanged);
  }

  async save() {
    const scriptApi = this.formRenderer!.nativeElement.getScriptApi();
    const response = await scriptApi.saveComposition();

    this.saveEvent.emit(response);

    console.log(response);
    console.log(scriptApi.getComposition());
    if (response.success) {
      this.snackBar.open('Modifica effettuata con successo', 'Chiudi', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['mat-accent'],
      });
      this.context.readonly = true;
      this.toggleFormRenderer();
    } else {
      this.snackBar.open('Si è verificato un errore durante il salvataggio', 'Chiudi', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['mat-warn'],
      });
    }
  }

  private changeLanguage(lang: string) {
    const scriptApi = this.formRenderer!.nativeElement?.getScriptApi();
    if(scriptApi) {
      scriptApi.setFormLanguage(lang);
    }
  }

  enableEditMode() {
    this.context.readonly = false;
    this.toggleFormRenderer();
  }

  togglePresentationMode() {
    if (this.context.readonly) {
      this.context.presentationMode = !this.context.presentationMode;
      this.toggleFormRenderer();
    }
  }

  private toggleFormRenderer() {
    const scriptApi = this.formRenderer!.nativeElement.getScriptApi();
    scriptApi.destroy();
    this.formChanged = false;
    this.formChangedEvent.emit(this.formChanged);
    this.showFormRenderer = false; // Disabilita il rendering
    this.cdr.detectChanges(); // Forza il rilevamento dei cambiamenti per distruggere immediatamente il componente
    this.showFormRenderer = true; // Riabilita il rendering
  }

  private hideElements() {
    const scriptApi = this.formRenderer?.nativeElement.getScriptApi();
    if (scriptApi) {
      this.elementsToHide.forEach((elementId) => {
        scriptApi.hideFormElement(elementId);
      });
    } else {
      console.error('scriptApi non disponibile');
    }
  }
}
